// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__aTHUA","sendOtp":"AuthorizeToLogin_sendOtp__RYDWq"};